import React, { useState, useEffect } from "react";
import HeaderBar from "../../components/header/headerBar";
import { TextBox, Textarea } from "../../components/textfield";
import { Table, TableColumn } from "../../components/table";
import MainButton from "../../components/button/mainButton";
import { AlertOutlined } from "@ant-design/icons";
import {
  mdiPrinter,
  mdiCheckCircleOutline,
  mdiAlertOctagram,
  mdiAlertOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { numberWithCommas } from "../../helpers/functions";
import { InputNumber, Modal, Spin, notification } from "antd";
import EmptyModel from "../../components/modal/emptyModal";
import Input from "../../components/textfield/input";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import jsonNotification from "../../helpers/notification";
interface Props {
  title1: string;
  title2: string;
  backgroundColor?: string;
}

interface ParamTypes {
  id: string;
  approval: string;
}

const DetailCashier = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const { isFetchedUser, socket } = useSelector((state: any) => state);
  const [dataSO, setDataSO] = useState<any>({});
  const [dataApproval, setDataApproval] = useState<any>({});

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isWaitingDiscount, setIsWaitingDiscount] = useState<boolean>(false);
  const [confirmDiscountText, setConfirmDiscountText] = useState<string>("");
  const [isMode, setIsMode] = useState<string | null>("");
  const columns = [
    {
      title: "",
      align: "",
      width: "70px",
    },
    {
      title: "รายการ/List",
      align: "center",
      width: "250px",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      align: "center",
      width: "250px",
    },
    {
      title: "จำนวน/Quantity",
      align: "center",
    },
    {
      title: "หน่วย/Unit",
      align: "center",
    },
    {
      title: "ฟรี/Free",
      align: "center",
      width: "250px",
    },
    {
      title: "ส่วนลดพิเศษ/Special Discount",
      width: "250px",
      align: "center",
    },
    {
      title: "ราคาพิเศษ/Special Price",
      width: "250px",
      align: "center",
    },
    {
      title: "ส่วนลด/Discount(Baht,%)",
      align: "center",
    },
    {
      title: "ราคารวม/Total Price",
      width: "250px",
      align: "center",
    },
    {
      title: "หมายเหตุ/Remark",
      align: "center",
    },
  ];
  const columnsPro = [
    {
      title: "",
      align: "",
    },
    {
      title: "รายการ/List",
      align: "center",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      align: "center",
    },
    {
      title: "จำนวน/Quantity",
      align: "center",
    },
    {
      title: "หน่วย/Unit",
      align: "center",
    },
    {
      title: "ฟรี/Free",
      align: "center",
    },
    {
      title: "ส่วนลด/Discount(Baht,%)",
      align: "center",
    },
    {
      title: "ราคารวม/Total Price",
      align: "center",
    },
    {
      title: "หมายเหตุ/Remark",
      align: "center",
    },
  ];
  const { id, approval } = useParams<ParamTypes>();

  useEffect(() => {
    console.log(search);
    getSO();
    getApproval();
  }, [id, approval]);

  useEffect(() => {
    setIsMode(query.get("mode"));
    console.log(isMode);
    if (query.get("mode") === "approval") setIsWaitingDiscount(false);
  }, [search]);

  useEffect(() => {
    if (isFetchedUser && !socket.loadingCashier && isMode !== "approval")
      setTimeout(() => {
        dispatch({
          type: "SET_SOCKET",
          data: {
            ...socket,
            loadingCashier: true,
          },
        });
        socket.io?.on("cashierEvent", (req: any) => {
          setIsWaitingDiscount(false);
          notification.open({
            message: "Notification",
            description: req.message,
            duration: 0,
            icon: <AlertOutlined style={{ color: "#e76464" }} />,
          });
          getSO();
        });
        console.log(socket.io);
      }, 1500);
  }, [isFetchedUser, socket]);

  const Banner: React.FC<Props> = ({
    title1,
    title2,
    backgroundColor = "#fff",
  }) => {
    return (
      <div
        className="col-5"
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "50px",
          backgroundColor: backgroundColor,
          padding: "10px 20px",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: "16px" }}>
          <b>{title1}</b>
        </div>
        <div style={{ fontSize: "20px" }}>
          <b>{title2}</b>
        </div>
      </div>
    );
  };

  const getSO = () => {
    axios.get(`/so/get-so?soId=${id}`).then((res) => {
      setDataSO(res?.data);
      let { status } = res?.data;
      if (
        status === "waiting_discount_approve" &&
        query.get("mode") !== "approval"
      ) {
        setIsWaitingDiscount(true);
      }
    });
  };
  const getApproval = () => {
    if (approval) {
      axios.get(`/notification/status/${approval}`).then((res) => {
        setDataApproval(res?.data);
      });
    }
  };

  const submitConfirm = () => {
    axios.post(`/cashier/isConfirm/${id}`, dataSO).then((res) => {
      if (res.status === 200) {
        let { newData } = res?.data;
        if (newData.statusCashier === "waiting_discount_approve") {
          setIsWaitingDiscount(true);
        } else if (newData.statusCashier === "done") {
          setIsOpen(true);
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        }
      }
    });
  };
  const submitApproval = () => {
    axios.post(`/cashier/isApproval/${id}`, { approval }).then((res) => {
      if (res.status === 200) {
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    });
  };
  const submitDisapproval = () => {
    axios.post(`/cashier/isDisapproval/${id}`, { approval }).then((res) => {
      if (res.status === 200) {
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    });
  };

  const onConfirmDiscountText = (index: number, val: string) => {
    let data: any = dataSO?.items;
    data[index]["discount"] = val;

    let pattern = /%/;
    let result = pattern.test(val);
    if (result) {
      let reDiscount = val.replace("%", "");
      console.log("Percent", parseInt(reDiscount));
      data[index]["discountPercent"] = parseInt(reDiscount);
    } else {
      let percent = ((parseInt(val) || 0) / data[index]?.totalPrice) * 100 || 0;
      console.log("Percent", percent);
      data[index]["discountPercent"] = percent;
    }

    setDataSO({ ...dataSO, items: data });
  };

  useEffect(() => {
    console.log(confirmDiscountText);
  }, [confirmDiscountText]);

  const calculateDiscount = (discount: string, total: number) => {
    let pattern = /%/;
    let result = pattern.test(discount);
    if (result) {
      let reDiscount = discount.replace("%", "");
      return total - (total * parseInt(reDiscount)) / 100;
    }
    console.log((parseInt(discount) / total) * 100 + "%");
    return total - (parseInt(discount) || 0);
  };

  const displayDiscount = (discount: string) => {
    let pattern = /%/;
    let result = pattern.test(discount);
    if (result) {
      return discount;
    }
    return (parseInt(discount) || "") == ""
      ? ""
      : numberWithCommas(parseInt(discount), 2);
  };

  const totalAmountAll = dataSO?.items?.reduce(
    (total: number, item: any) => total + item?.price * item?.quantity,
    0
  );

  const totalPrice = dataSO?.items?.reduce(
    (total: number, item: any) => total + item?.totalPrice,
    0
  );
  const totalPriceDiscount = dataSO?.items?.reduce(
    (total: number, item: any) =>
      total + (item?.totalPrice * item?.discountPercent) / 100,
    0
  );
  const totalDiscount = dataSO?.items?.reduce((total: number, item: any) => {
    return total + item?.specialPrice;
  }, 0);
  const totalAmountDiscount = dataSO?.items?.reduce(
    (total: number, item: any) => {
      return total + item?.price * item?.quantity - item?.specialPrice;
    },
    0
  );

  const totalDiscountPercent = dataSO?.items?.reduce(
    (total: number, item: any) => {
      return (
        total +
        ((item?.price * item?.quantity - item?.specialPrice) *
          item?.discountPercent) /
          100
      );
    },
    0
  );

  const totalDiscountFull = dataSO?.totalDiscountAmount - totalDiscount;
  const totalDiscountAll =
    totalDiscount + totalDiscountPercent + totalDiscountFull;

  console.log(
    "ราคาจริง : ",
    totalAmountAll,
    "ราคาจริงหักส่วนลด : ",
    totalAmountDiscount,
    totalDiscount,
    totalDiscountPercent,
    totalDiscountFull
  );
  return (
    <div>
      {isMode === "approval" ? (
        <HeaderBar title={`Notification/Approval`} btnBack />
      ) : (
        <HeaderBar title={`CASHIER /${dataSO?.code}`} btnBack />
      )}
      <EmptyModel show={isWaitingDiscount} btnClose={false} width="650px">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center">
            <Icon path={mdiAlertOutline} color="#E76464" size="120" />
          </div>

          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              ส่วนลดเกินกำหนด ต้องรอการอนุมัติ/Overdue Discount Awaiting
              Approval
            </div>
          </div>
        </div>
      </EmptyModel>
      <EmptyModel show={isOpen} btnClose={false} width="650px">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center">
            <Icon path={mdiCheckCircleOutline} color="#86CFC6" size="120" />
          </div>

          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              บันทึกรายการเรียบร้อยแล้ว/List Saved Successfully.
            </div>
          </div>
        </div>
      </EmptyModel>
      <div className="page-container" style={{ padding: "20px 80px" }}>
        <div className="card-view" style={{ padding: "20px 40px" }}>
          <div className="row">
            <TextBox
              className="col-3"
              title="รหัสลูกค้า/CN"
              value={dataSO?.customerCode}
            />
            <TextBox
              className="col-3"
              title="รหัสการขาย/SO"
              value={dataSO?.code}
            />
            <TextBox
              className="col-3"
              title="เลขที่ใบยา/Ref.VN"
              value={dataSO?.vn}
            />
            <TextBox
              className="col-3"
              title="ชื่อลูกค้า/CUSTOMER NAME"
              value={`${dataSO?.customer}`}
            />
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          <Table
            header={dataSO?.purchaseType === "promotion" ? columnsPro : columns}
            width="1920px"
          >
            {dataSO?.items?.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn>{index + 1}</TableColumn>
                <TableColumn>{item?.name}</TableColumn>
                <TableColumn align="center">
                  {numberWithCommas(item?.price, 2)}
                </TableColumn>
                <TableColumn align="center">{item?.quantity}</TableColumn>
                <TableColumn align="center">{item?.number}</TableColumn>
                <TableColumn align="left">
                  {item?.free?.productFree?.name}
                </TableColumn>
                {dataSO?.purchaseType !== "promotion" && (
                  <TableColumn align="right">
                    {numberWithCommas(item?.specialPrice, 2)}
                  </TableColumn>
                )}
                {dataSO?.purchaseType !== "promotion" && (
                  <TableColumn align="right">
                    {numberWithCommas(item?.specialDiscount, 2)}
                  </TableColumn>
                )}
                <TableColumn
                  align="right"
                  // onClick={() => confirmDiscount(index)}
                >
                  {dataSO?.statusCashier === "done" ? (
                    <div
                      style={{
                        color:
                          item?.discountPercent >= item?.maximumDiscount
                            ? "red"
                            : "#000000",
                      }}
                    >
                      {displayDiscount(item?.discount)}
                    </div>
                  ) : (
                    <Input
                      title=""
                      value={item?.discount}
                      inputStyle={{ textAlign: "right" }}
                      onChange={(e: any) =>
                        onConfirmDiscountText(index, e.target.value)
                      }
                      customText={
                        <div
                          style={{
                            color:
                              item?.discountPercent >= item?.maximumDiscount
                                ? "red"
                                : "#000000",
                          }}
                        >
                          {displayDiscount(item?.discount)}
                        </div>
                      }
                    />
                  )}
                </TableColumn>
                <TableColumn align="right">
                  {numberWithCommas(
                    calculateDiscount(item?.discount, item?.totalPrice),
                    2
                  )}
                </TableColumn>
                <TableColumn align="right">
                  <InputNumber
                    type="text"
                    style={{
                      width: "100%",
                      height: "auto",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    value={item?.remark}
                    min={0}
                    onChange={(e: any) => {
                      let latestData = dataSO;
                      latestData.items[index].remark = e;
                      setDataSO(latestData);
                    }}
                    controls={false}
                  ></InputNumber>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <div className="row">
          <div className="col-6">
            <table width="100%" style={{ fontSize: "14px" }}>
              <tr
                style={{
                  height: "50px",
                }}
              >
                <td
                  style={{
                    borderRight: "0px solid #aaa",
                    padding: "0px 0px",
                  }}
                >
                  <Textarea
                    placeholder="หมายเหตุ/Note"
                    value={dataSO?.note}
                    onChange={(e) => {
                      setDataSO({ ...dataSO, note: e.target.value });
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                </td>
              </tr>
              <tr
                style={{
                  height: "50px",
                }}
              >
                <td
                  style={{
                    borderRight: "0px solid #aaa",
                    padding: "0px 0px",
                  }}
                >
                  <Textarea
                    placeholder="ที่อยู่ออกบิล/Billing Address"
                    value={dataSO?.billingAddress}
                    onChange={(e) => {
                      setDataSO({ ...dataSO, billingAddress: e.target.value });
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                </td>
              </tr>
              <tr
                style={{
                  backgroundColor: "#fff",
                  height: "50px",
                }}
              >
                <td
                  style={{
                    borderRight: "0px solid #aaa",
                    padding: "0px 10px",
                    color: "#000",
                  }}
                >
                  <b style={{ fontFamily: "Sarabun" }}>ยอดเงินรวม/Total</b>
                  <b
                    style={{
                      float: "right",
                      fontFamily: "Sarabun",
                    }}
                  >
                    {numberWithCommas(dataSO?.balanceAfterAllDiscount, 2)}
                  </b>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-6" style={{ padding: "10px" }}>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    โอนคอร์ส/Filler (Juvederm Vollift)
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    <b>0</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    ยอดเงินส่วนลด/Discount amount.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    <b>{numberWithCommas(totalPriceDiscount, 2)}</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#E76464",
                      color: "#fff",
                    }}
                  >
                    ยอดเงินหลังหักส่วนลดทั้งหมด/
                    <br />
                    Balance after all discounts.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#fff",
                      background: "#E76464",
                    }}
                  >
                    <b>
                      {numberWithCommas(totalPrice - totalPriceDiscount, 2)}
                    </b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                      color: "#000",
                    }}
                  >
                    ยอดเงินมัดจำ/Deposit amount.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#000",
                      background: "#fff",
                    }}
                  >
                    <b>{numberWithCommas(dataSO?.depositAmount, 2)}</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#D3D8DD",
                      color: "#000",
                    }}
                  >
                    ยอดเงินรวมที่ต้องชำระ/Total amount paid.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#000",
                      background: "#D3D8DD",
                    }}
                  >
                    <b>
                      {numberWithCommas(
                        totalPrice -
                          totalPriceDiscount -
                          dataSO?.depositAmount -
                          dataSO?.paidAmount,
                        2
                      )}
                    </b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        {approval && dataApproval?.userActived && (
          <div
            className="card-view"
            style={{ padding: "20px 40px", marginTop: "1.5rem" }}
          >
            <div className="row">
              <div
                className="col-4"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="row">
                  <div className="col-6">
                    <h6>สถานะ/Status</h6>
                  </div>
                  <div className="col-6">
                    <div
                      style={{
                        background: dataApproval?.isActived
                          ? "#C7F0D8"
                          : "#E76464",
                        color: "#ffff",
                        textAlign: "center",
                        padding: "0.5rem 1.5rem",
                        borderRadius: "2rem",
                      }}
                    >
                      {dataApproval?.isActived ? "Approved" : "Disapproved"}
                    </div>
                  </div>
                </div>
              </div>
              <TextBox
                className="col-4"
                title="ผู้อนุมัติ/Approver By"
                value={dataApproval?.userActived}
              />
              <TextBox
                className="col-4"
                title="ผู้สร้างคำขอ/Request By"
                value={dataApproval?.createdUser}
              />
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          {isMode === "approval" &&
          dataSO?.statusCashier === "waiting_discount_approve" ? (
            <>
              <MainButton
                title="ไม่อนุมัติ/Disapproved"
                background="#E76464"
                className="mg-10"
                onClick={() => submitDisapproval()}
              />
              <MainButton
                title="อนุมัติ/Approved"
                background="#4D7E7F"
                className="mg-10"
                onClick={() => submitApproval()}
              />
            </>
          ) : (
            ""
          )}
          {dataSO?.statusCashier === "none" && (
            <MainButton
              title="บันทึกรายการ/Submit"
              background="#4285F4"
              className="mg-10"
              onClick={() => submitConfirm()}
            >
              <Icon path={mdiPrinter} size="20" color="#fff" />
            </MainButton>
          )}
          {dataSO?.statusCashier === "done" && (
            <>
              <MainButton
                title="พิมพ์ใบแจ้งหนี้/Print Invoice"
                background="#4285F4"
                className="mg-10"
                onClick={() => history.push(`/cashier/${dataSO?._id}/invoice`)}
              >
                <Icon path={mdiPrinter} size="20" color="#fff" />
              </MainButton>
              <MainButton
                title="ชำระเงิน/Payment"
                background="#5BAEA9"
                className="mg-10"
                onClick={() => history.push(`/cashier/${dataSO?._id}/payment`)}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default DetailCashier;
